import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SettingsBrandingPage = lazy(() => import('@/pages/settings/branding'));

export const Route = createFileRoute('/settings/branding')({
  component: function SettingsBrandingRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SettingsBrandingPage />
      </Suspense>
    );
  },
});
